import {
  moduleNamespace,
  SET_RESALE_ADDONS,
} from "./constants";
import {writeSession} from "../../sharedGlobal";
import _ from "lodash";

/**
 * Fetch resellable addon products from the server.
 */
export function fetchResaleAddons({ commit }) {
  return axios.get('/merchant/resale-addons')
    .then(({ data }) => {
      commit(SET_RESALE_ADDONS, data);
    })
    .catch(e => {
      console.error(e);
      Swal.fire({
        type: 'error',
        text: 'An unknown error occurred, please contact support@hikeseo.co',
      });
    });
}

/**
 * JSON encode and write the user-created addon products to session.
 */
export function writeAddonsToSession(addons) {
  writeSession(
    moduleNamespace,
    'addons',
    JSON.stringify(addons)
  );
}

/**
 * Used to determine if a given addon price object is required, by referring to the
 * software price configuration.
 *
 * The rules are, in plain english:
 * - If the software GBP monthly price is > 0 : the equivalent is required on the addon.
 * - If the software GBP annual price is > 0 : the equivalent is required on the addon.
 * - If the software USD monthly price is > 0 : the equivalent is required on the addon.
 * - If the software USD annual price is > 0 : the equivalent is required on the addon.
 */
export function isAddonPriceRequired(
  supportedCurrencies,
  softwarePrices,
  resaleAddonPrice,
) {
  let enabledCurrencies = [];
  Object.entries(supportedCurrencies)
    .forEach(([currencyCode, {enabled}]) => {
      if (enabled) {
        enabledCurrencies.push(currencyCode);
      }
    });

  const {
    currency: resaleAddonCurrency, // GBP
    billing_period: resaleBillingPeriod, // ONCE
  } = resaleAddonPrice;

  /**
   * Walk through the user defined software prices and check if monthly/annual is set on each.
   * If we find one that is set, mark required as true.
   * If not, stick with the rolling value.
   *
   * Depending on the billing period of the price we're questioning, the necessity of the field is determined
   * from a different software field
   */
  const billingPeriodToCheck = resaleBillingPeriod === 'YEAR' ? 'annualRaw' : 'monthlyRaw';

  let isRequired = false;
  _.forEach(softwarePrices, (softwarePrice) => {
      isRequired = softwarePrice[billingPeriodToCheck] > 0 ?
        true :
        isRequired;
  });


  let matchedCurrency = false;
  if (isRequired || resaleBillingPeriod === 'ONCE') {
    matchedCurrency = enabledCurrencies.includes(resaleAddonCurrency);
  }

  const matchedBillingPeriod = isRequired || resaleBillingPeriod === 'ONCE';

  return matchedBillingPeriod && matchedCurrency;
}
